import { GET_ACCESS_CODES_FAILURE, GET_ACCESS_CODES_REQUEST, GET_ACCESS_CODES_SUCCESS } from '../actions/access_codes'

export const getAccessCodes = (
  state = {
    isFetching: false,
    data: null,
    errorMessage: null,
    count: 0,
    requestUrl: '',
  },
  action
) => {
  switch (action.type) {
    case GET_ACCESS_CODES_REQUEST:
      return {
        ...state,
        data: null,
        isFetching: true,
        errorMessage: null,
        count: 0,
        requestUrl: '',
      }
    case GET_ACCESS_CODES_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        data: action.response.results,
        count: action.response.count,
        requestUrl: action.requestUrl,
      }
    case GET_ACCESS_CODES_FAILURE:
      return {
        ...state,
        errors: null,
        data: null,
        isFetching: false,
        errorMessage: action.error,
        count: 0,
        requestUrl: action.requestUrl,
      }
    default:
      return state
  }
}
